import React from 'react';
import classNames from 'classnames/bind';
import style from './MyAccount.module.scss';
import Layout from '../../common/Layout/Layout';
import InputText from '../../common/input/InputText';
import ButtonCommon from '../../common/button/ButtonCommon';
import Message from '../../common/message/Message';
import PasswordChangeCompleteModal from '../changePassword/PasswordChangeCompleteModal';
import useExpiredAndUpdatePasswordForm from '../changePassword/useExpiredAndUpdatePasswordForm';
import { useAccountStore } from '../hooks/useAccountStore';
import { ROLE_TYPE_NAME } from '../../settings/administrator/AdministratorManagement';
import { getCookie } from '../../../util/cookie';

const cx = classNames.bind(style);

const GENDER_NAME: Record<string, string> = { MALE: '남', FEMALE: '여' };

const MyAccount = () => {
  const account = useAccountStore((state) => state.data);
  const passwordExpiryDate = getCookie('passwordExpiryDate');
  const {
    passwordRegister,
    newPasswordRegister,
    newPasswordRepeatRegister,
    onSubmit,
    errors,
    showChangedPasswordModal,
    goToLoginPage,
    toastMessage,
  } = useExpiredAndUpdatePasswordForm();

  return (
    <Layout>
      <h2>내 정보</h2>
      <div className={cx('sections')}>
        <section className={cx('card')}>
          <h3>계정 정보</h3>
          <dl className={cx('info')}>
            <dt>이름</dt>
            <dd>{account.name || '-'}</dd>
            <dt>이메일(아이디)</dt>
            <dd>{account.email || '-'}</dd>
            <dt>휴대폰</dt>
            <dd>{account.phone || '-'}</dd>
            <dt>성별</dt>
            <dd>{GENDER_NAME[account.gender] ?? '-'}</dd>
            <dt>생년월일</dt>
            <dd>{account.birthDate || '-'}</dd>
            <dt>권한</dt>
            <dd>{account.roleType ? ROLE_TYPE_NAME[account.roleType] : '-'}</dd>
            <dt>비밀번호 만료일</dt>
            <dd>{passwordExpiryDate || '-'}</dd>
          </dl>
          <p className={cx('note')}>정보 변경은 마스터 관리자에게 요청해 주세요.</p>
        </section>

        <section className={cx('card')}>
          <h3>비밀번호 변경</h3>
          <form className={cx('form')} onSubmit={onSubmit}>
            <label htmlFor={'my-password'}>현재 비밀번호</label>
            <InputText
              {...passwordRegister}
              id={'my-password'}
              placeholder={'현재 사용하는 비밀번호'}
              password
            />
            {errors.password?.message && <span className={cx('error')}>{errors.password.message}</span>}
            <label htmlFor={'my-new-password'}>새 비밀번호</label>
            <InputText {...newPasswordRegister} id={'my-new-password'} placeholder={'새 비밀번호'} password />
            {errors.newPassword?.message && <span className={cx('error')}>{errors.newPassword.message}</span>}
            <InputText
              {...newPasswordRepeatRegister}
              aria-label={'새 비밀번호 확인'}
              placeholder={'새 비밀번호 다시 입력'}
              password
            />
            {errors.newPasswordRepeat?.message && (
              <span className={cx('error')}>{errors.newPasswordRepeat.message}</span>
            )}
            <ul className={cx('rules')}>
              <li>영문, 숫자, 특수문자 중 3종류 이상, 8자리 이상</li>
              <li>특수 문자 중 $, &lt;, &gt;, &apos;, &quot;, ?, / 는 사용할 수 없습니다.</li>
              <li>현재 비밀번호와 직전 2개 비밀번호는 다시 사용할 수 없습니다.</li>
              <li>변경하면 로그인된 모든 기기에서 로그아웃됩니다.</li>
            </ul>
            <ButtonCommon size={'large'} submitType>
              비밀번호 변경
            </ButtonCommon>
          </form>
        </section>
      </div>

      {showChangedPasswordModal && <PasswordChangeCompleteModal logout={goToLoginPage} />}
      {toastMessage && (
        <Message>
          <span>{toastMessage}</span>
        </Message>
      )}
    </Layout>
  );
};

export default MyAccount;
